import React from 'react';
import { IconProps, IconWrap } from './IconWrap';
import styled from 'styled-components';

export const IconEye = styled(({ color = '#7C86A3', width = 14, height = 11, ...props }: IconProps) => {
    return (
        <IconWrap {...props} viewBox="0 0 14 11" width={width} height={height} iconClass="eye">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.58511 5.02979C9.58511 6.25708 8.59019 7.25201 7.36289 7.25201C6.13559 7.25201 5.14067 6.25708 5.14067 5.02979C5.14067 3.80249 6.13559 2.80756 7.36289 2.80756C8.59019 2.80756 9.58511 3.80249 9.58511 5.02979ZM8.474 5.02979C8.474 5.64344 7.97654 6.1409 7.36289 6.1409C6.74924 6.1409 6.25178 5.64344 6.25178 5.02979C6.25178 4.41614 6.74924 3.91867 7.36289 3.91867C7.97654 3.91867 8.474 4.41614 8.474 5.02979Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.36289 0.0297852C10.4693 0.0297852 13.0795 2.15441 13.8195 5.02979C13.0795 7.90517 10.4693 10.0298 7.36289 10.0298C4.25649 10.0298 1.64632 7.90517 0.90625 5.02979C1.64632 2.15441 4.25649 0.0297852 7.36289 0.0297852ZM7.36289 8.91867C4.87646 8.91867 2.76918 7.28431 2.06135 5.02979C2.76918 2.77526 4.87646 1.1409 7.36289 1.1409C9.84931 1.1409 11.9566 2.77526 12.6644 5.02979C11.9566 7.28431 9.84931 8.91867 7.36289 8.91867Z"
                fill={color}
            />
        </IconWrap>
    );
})``;
